/**
 * Utility functions for handling offer-related operations
 */

/**
 * Checks if an offer has expired based on its expiration date
 * @param expiresAt - ISO 8601 date string representing when the offer expires
 * @returns boolean - true if the offer has expired, false otherwise
 */
export const isOfferExpired = (expiresAt: string): boolean => {
  console.log("expiresAt", expiresAt);
  if (!expiresAt) return true; // If no expiration date is provided, consider it expired

  const expirationDate = new Date(expiresAt);
  const currentDate = new Date();

  console.log("expirationDate", expirationDate);
  console.log("currentDate", currentDate);
  // Check if the expiration date is valid
  if (isNaN(expirationDate.getTime())) {
    console.warn("Invalid expiration date provided:", expiresAt);
    return true; // Consider invalid dates as expired for safety
  }

  return currentDate > expirationDate;
};
